import { Colors } from '../consts/Colors.js';
import AbstractScene from './AbstractScene.js';

export default class Preloader extends AbstractScene {
    constructor() {
        super({ key: 'Preloader' });
    }

    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();

        this.assetsReady = false;
        this.dataReady = false;

        const lang = (this.game.data.lang || 'fr').toLowerCase().split('-')[0];

        const loadingTexts = {
            fr: 'Chargement...',
            it: 'Caricamento...',
            pol: 'Ładowanie...',
            de: 'Laden...',
            es: 'Cargando...',
            en: 'Loading...',
        };

        const loadingText = loadingTexts[lang] || 'Loading...';

        this.loadingText = this.make
            .text({
                x: this.width / 2,
                y: this.height / 2,
                text: loadingText,
                style: {
                    font: '32px Montserrat',
                    fill: Colors.Text.BleuNovotel,
                    stroke: '#f9f5ec',
                    strokeThickness: 8,
                },
            })
            .setOrigin(0.5);

        // 🔹 Chargement des assets
        this.loadSprites();

        // 🔹 Progression du chargement
        this.load.on('progress', (value) => {
            this.loadingText.text = loadingText + Math.floor(value * 100) + '%';
        });

        this.load.once('complete', () => {
            this.scene.start('DataLoader');
        });

        // 🔹 Logs debug (optionnel)
        // this.load.on('addfile', (file) => {
        //     console.log('[addfile]', file.type, file.key, file.src);
        // });
        // this.load.on('filecomplete', (key, type) => {
        //     console.log('[filecomplete]', type, key);
        // });
        // this.load.on('loaderror', (fileObj) => {
        //     console.warn('[loaderror]', fileObj?.src || fileObj, fileObj?.error || '');
        // });
    }

    maybeStartNextScene() {
        if (this.assetsReady && this.dataReady) {
            this.nextScene();
        }
    }

    // =====================================================
    // ===============  SPRITES / ASSETS  ==================
    // =====================================================

    loadSprites() {
        // ⚠️ On garde le même comportement qu’avant :
        // tout est chargé (communs + variantes par langue),
        // mais le code est rangé proprement.
        this.loadCommonSprites();
        this.loadFrenchSprites();
        // this.loadEnglishSprites();
        // this.loadItalianSprites();
        //this.loadPolishSprites();
        //this.loadGermanSprites();
        // this.loadSpanishSprites();
    }

    // ----------------- COMMUN À TOUTES LES LANGUES -----------------
    loadCommonSprites() {
        // intro (fond, logo générique, décor)
        this.load.image('introBack', 'assets/images/intro/background.png'); // (optionnel si pas utilisé)
        this.load.image('background', 'assets/images/intro/background.png');
        this.load.image('logo', 'assets/images/intro/logo.png');
        this.load.image('hat1', 'assets/images/intro/hat-1.png');
        this.load.image('hat2', 'assets/images/intro/hat-2.png');
        this.load.image('demo-poster', 'assets/images/demo-poster.png');

        // logo fallback (autres langues)
        this.load.image('logo-intro-default', 'assets/images/intro/logo-intro-default.png');

        // nav
        this.load.image('rond-bleu', 'assets/images/nav/backrond.png');

        // turn
        this.load.image('turn', 'assets/images/turn/icone_retourner.png');

        // activité 1 — commun
        this.load.image('background-activite-1', 'assets/images/activite-1/image-test-fond.png');
        this.load.image(
            'cadre-consigne-activite-1',
            'assets/images/activite-1/consigne/content_icon.png',
        );
        this.load.image(
            'poisson-consigne-activite-1',
            'assets/images/activite-1/consigne/poisson.png',
        );
        this.load.image('main-consigne-activite-1', 'assets/images/activite-1/consigne/main.png');
        this.load.image('loupe-consigne-activite-1', 'assets/images/activite-1/consigne/loupe.png');
        this.load.image('fleche-activite-1', 'assets/images/activite-1/cta-direction.png');
        this.load.image('question-icon-activite-1', 'assets/images/activite-1/container.png');
        this.load.image('attention-icon-activite-1', 'assets/images/activite-1/attention-icon.png');
        this.load.image('valide-icon-activite-1', 'assets/images/activite-1/valide-icon.png');
        this.load.image(
            'pas-valide-icon-activite-1',
            'assets/images/activite-1/pasvalide-icon.png',
        );
        this.load.image('bonne-rep-activite-1', 'assets/images/activite-1/bonne-reponse.png');
        this.load.image('mauvaise-rep-activite-1', 'assets/images/activite-1/mauvaise-reponse.png');
        this.load.image('animal-1-activite-1', 'assets/images/activite-1/image-grande-1.png');
        this.load.image('animal-2-activite-1', 'assets/images/activite-1/image-grande-2.png');
        this.load.image('animal-3-activite-1', 'assets/images/activite-1/image-grande-3.png');
        this.load.image('animal-4-activite-1', 'assets/images/activite-1/image-grande-4.png');
        this.load.image('animal-5-activite-1', 'assets/images/activite-1/image-grande-5.png');
        this.load.image(
            'container-activite-1',
            'assets/images/activite-1/content-fin-activite.png',
        );
        this.load.image('loupe', 'assets/images/activite-1/loupe.png');

        // activité 2 — commun
        this.load.image('background-activite-2', 'assets/images/activite-2/rorqual-perdu.jpg');
        this.load.image('background-activite-2b', 'assets/images/activite-2/decor-loop.png');
        this.load.image(
            'consigne-activite-2',
            'assets/images/activite-2/consigne/consigne_tuto.png',
        );
        this.load.image('slider-img-1-activite-2', 'assets/images/activite-2/slider/img1.png');
        this.load.image('slider-img-2-activite-2', 'assets/images/activite-2/slider/img2.png');
        this.load.image('slider-img-3-activite-2', 'assets/images/activite-2/slider/img3.png');
        this.load.image('slider-img-4-activite-2', 'assets/images/activite-2/slider/img4.png');
        this.load.image('slider-img-5-activite-2', 'assets/images/activite-2/slider/img5.png');
        this.load.image('slider-img-6-activite-2', 'assets/images/activite-2/slider/img6.png');
        this.load.image('slider-img-7-activite-2', 'assets/images/activite-2/slider/img7.png');
        this.load.image('slider-img-8-activite-2', 'assets/images/activite-2/slider/img8.png');
        this.load.image(
            'bouteille-vide-activite-2',
            'assets/images/activite-2/bouteille_message.png',
        );

        // activité 3 — fond + éléments communs
        this.load.image('background-activite-3', 'assets/images/activite-3/background.jpg');
        this.load.image('consigne-activite-3', 'assets/images/activite-3/consigne/icone_tuto.png');

        // FR (mais utilisés comme base) — on laisse en commun pour ne pas changer le comportement
        this.load.image('slider-img-4-activite-3', 'assets/images/activite-3/slider/img1.png');
        this.load.image('slider-img-1-activite-3', 'assets/images/activite-3/slider/img2.png');
        this.load.image('slider-img-6-activite-3', 'assets/images/activite-3/slider/img3.png');
        this.load.image('slider-img-2-activite-3', 'assets/images/activite-3/slider/img4.png');
        this.load.image('slider-img-5-activite-3', 'assets/images/activite-3/slider/img5.png');
        this.load.image('slider-img-3-activite-3', 'assets/images/activite-3/slider/img6.png');

        this.load.image('chaine-img-1-activite-3', 'assets/images/activite-3/chaine/img1.png');
        this.load.image('chaine-img-2-activite-3', 'assets/images/activite-3/chaine/img2.png');
        this.load.image('chaine-img-3-activite-3', 'assets/images/activite-3/chaine/img3.png');
        this.load.image('chaine-img-4-activite-3', 'assets/images/activite-3/chaine/img4.png');
        this.load.image('chaine-img-5-activite-3', 'assets/images/activite-3/chaine/img5.png');
        this.load.image('chaine-img-6-activite-3', 'assets/images/activite-3/chaine/img6.png');
        this.load.image('chaine-arrow-1-activite-3', 'assets/images/activite-3/chaine/arrow-1.png');
        this.load.image('chaine-arrow-2-activite-3', 'assets/images/activite-3/chaine/arrow-2.png');
        this.load.image('chaine-arrow-3-activite-3', 'assets/images/activite-3/chaine/arrow-3.png');
        this.load.image('chaine-arrow-4-activite-3', 'assets/images/activite-3/chaine/arrow-4.png');
        this.load.image('chaine-arrow-5-activite-3', 'assets/images/activite-3/chaine/arrow-5.png');

        this.load.image(
            'scroll-chaine-activite-3',
            'assets/images/activite-3/scroll_chaine_alimentaire.png',
        );
        this.load.image(
            'scroll-chaine-activite-b',
            'assets/images/activite-3/scroll_chaine_alimentaire_b.png',
        );
        this.load.image(
            'bouteille-vide-activite-3',
            'assets/images/activite-3/bouteille-message.png',
        );

        // activité 4 — commun
        this.load.image(
            'container-activite-4',
            'assets/images/activite-4/content-fin-activite.png',
        );
        this.load.image(
            'bouteille-vide-activite-4',
            'assets/images/activite-4/bouteille_message.png',
        );
        this.load.image('background-activite-4', 'assets/images/activite-4/background.png');
        this.load.image('consigne-activite-4', 'assets/images/activite-4/consigne/icone_tuto.png');
        this.load.image(
            'consigne-activite-4b',
            'assets/images/activite-4/consigne/icone_tuto_b.png',
        );

        // activité 4 — swipe images
        this.load.image('img-crabe-1', 'assets/images/activite-4/img1.png');
        this.load.image('img-crabe-2', 'assets/images/activite-4/img2.png');
        this.load.image('img-crabe-3', 'assets/images/activite-4/img3.png');
        this.load.image('img-crabe-4', 'assets/images/activite-4/img4.png');
        this.load.image('img-crabe-5', 'assets/images/activite-4/img5.png');
        this.load.image('circle-swipe', 'assets/images/activite-4/content_icon.png');

        // activité 4 — filets & poissons
        this.load.image('bateau-chalutier', 'assets/images/activite-4/bateau-chalutier.png');
        this.load.image('chalutier', 'assets/images/activite-4/chalutier.png');
        this.load.image('filet-1', 'assets/images/activite-4/filets/img1.png');
        this.load.image('filet-2', 'assets/images/activite-4/filets/img2.png');
        this.load.image('filet-3', 'assets/images/activite-4/filets/img3.png');
        this.load.image('filet-4', 'assets/images/activite-4/filets/img4.png');
        this.load.image('filet-5', 'assets/images/activite-4/filets/img5.png');
        this.load.image('filet-6', 'assets/images/activite-4/filets/img6.png');

        this.load.image('fish1', 'assets/images/activite-4/fish-1.png');
        this.load.image('fish2', 'assets/images/activite-4/fish-2.png');
        this.load.image('fish3', 'assets/images/activite-4/fish-3.png');
        this.load.image('fishSelected', 'assets/images/activite-4/fish-selected.png');
        this.load.image('filetSelected', 'assets/images/activite-4/filet-selected.png');

        this.load.image('crabe', 'assets/images/activite-4/crabe.png');
        this.load.image('labyrinthe', 'assets/images/activite-4/labyrinthe.png');
        this.load.image('poulpe', 'assets/images/activite-4/poulpe.png');
        this.load.image('requin', 'assets/images/activite-4/requin.png');

        // End — fond
        this.load.image('endBackground', 'assets/images/end/background.png');

        // icones
        this.load.image('arrow-right', 'assets/images/icones/arrow-right-01.png');
        this.load.image('arrow-right-white', 'assets/images/icones/arrow-right-02.png');
        this.load.image('video-start', 'assets/images/icones/play-circle-02.png');
        this.load.image('video-pause', 'assets/images/icones/pause-circle-02.png');
        this.load.image('cta-close', 'assets/images/icones/CTA_close.png');
        this.load.image('video-avancer', 'assets/images/icones/avancer.png');
        this.load.image('video-reculer', 'assets/images/icones/reculer.png');
        this.load.image('attention', 'assets/images/icones/attention-icon.png');
        this.load.image('audio-wave', 'assets/images/icones/audio.png');
        this.load.image('audio-play', 'assets/images/icones/audio-play.png');
        this.load.image('icone_inter', 'assets/images/icones/iconeinter.png');
        this.load.image('icone_check', 'assets/images/icones/icone_check.png');
        this.load.image(
            'icone_check_without_shadow',
            'assets/images/icones/icone_check_without_shadow.png',
        );
        this.load.image('icone_help', 'assets/images/icones/help-circle.png');
        this.load.image('burger', 'assets/images/icones/icone-menu.png');
        this.load.image('close', 'assets/images/icones/close-menu.png');
        this.load.image('bouteilleVide', 'assets/images/bouteilleVide.png');

        // audios --- Activité 2
        this.load.audio('audioBateau', 'assets/audios/audio-bateau.wav');
        this.load.audio('audioPlage', 'assets/audios/audio-plage.wav');
        this.load.audio('audioTravaux', 'assets/audios/audio-travaux.wav');
        this.load.audio('audioFull', 'assets/audios/audio-full.mp3');
    }

    // ----------------- FRANÇAIS -----------------
    loadFrenchSprites() {
        // intro FR
        this.load.image('logo-intro', 'assets/images/intro/logo-intro.jpg');

        // activité 1 FR
        this.load.image('bouteille-vide-activite-1', 'assets/images/activite-1/image.png');

        // activité 3 FR (déjà chargée en commun, on ne rajoute rien ici)

        // activité 4 FR
        this.load.image(
            'bouteille-vide-activite-4',
            'assets/images/activite-4/bouteille_message.png',
        );

        // End FR
        this.load.image('endScreen', 'assets/images/end/end-screen.png');

        // videos FR
        this.load.video(
            'chaineAlimentaireVideo',
            'assets/videos/chaine-alimentaire_vp9_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'crabeBleuVideo',
            'assets/videos/crabe-bleu_vp9_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'introVideo',
            'assets/videos/intro_vp9_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'outroVideo',
            'assets/videos/outro_vp9_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'generiqueVideo',
            'assets/videos/generique_vp9_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'posidonieVideo',
            'assets/videos/posidonie_vp9_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'rorqualVideo',
            'assets/videos/rorqual_vp9_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
    }

    // ----------------- ANGLAIS -----------------
    loadEnglishSprites() {
        // intro EN
        this.load.image('logo-intro-en', 'assets/images/intro/logo-intro-en.jpg');

        // activité 1 EN
        this.load.image('bouteille-vide-activite-1-en', 'assets/images/activite-1/image-en.png');

        // activité 3 EN
        this.load.image(
            'slider-img-4-activite-3-en',
            'assets/images/activite-3/slider/img1-en.png',
        );
        this.load.image(
            'slider-img-1-activite-3-en',
            'assets/images/activite-3/slider/img2-en.png',
        );
        this.load.image(
            'slider-img-6-activite-3-en',
            'assets/images/activite-3/slider/img3-en.png',
        );
        this.load.image(
            'slider-img-2-activite-3-en',
            'assets/images/activite-3/slider/img4-en.png',
        );
        this.load.image(
            'slider-img-5-activite-3-en',
            'assets/images/activite-3/slider/img5-en.png',
        );
        this.load.image(
            'slider-img-3-activite-3-en',
            'assets/images/activite-3/slider/img6-en.png',
        );

        this.load.image(
            'chaine-img-1-activite-3-en',
            'assets/images/activite-3/chaine/img1-en.png',
        );
        this.load.image(
            'chaine-img-2-activite-3-en',
            'assets/images/activite-3/chaine/img2-en.png',
        );
        this.load.image(
            'chaine-img-3-activite-3-en',
            'assets/images/activite-3/chaine/img3-en.png',
        );
        this.load.image(
            'chaine-img-4-activite-3-en',
            'assets/images/activite-3/chaine/img4-en.png',
        );
        this.load.image(
            'chaine-img-5-activite-3-en',
            'assets/images/activite-3/chaine/img5-en.png',
        );
        this.load.image(
            'chaine-img-6-activite-3-en',
            'assets/images/activite-3/chaine/img6-en.png',
        );

        // activité 4 EN
        this.load.image(
            'bouteille-vide-activite-4-en',
            'assets/images/activite-4/bouteille_message_en.png',
        );

        // End EN
        this.load.image('endScreen-en', 'assets/images/end/end-screen-en.png');

        // vidéos EN
        this.load.video('chaineAlimentaireVideo-en', 'assets/videos/en/chaine-alimentaire.mp4');
        this.load.video('crabeBleuVideo', 'assets/videos/en/crabe-bleu.mp4');
        this.load.video('posidonieVideo-en', 'assets/videos/en/posidonie.mp4');
        this.load.video('rorqualVideo-en', 'assets/videos/en/rorqual.mp4');
        this.load.video('generiqueVideo-en', 'assets/videos/generique.mp4');
        this.load.video('introVideo-en', 'assets/videos/en/intro.mp4');
        this.load.video('outroVideo-en', 'assets/videos/en/outro.mp4');
    }

    // ----------------- ITALIEN -----------------
    loadItalianSprites() {
        // activité 3 IT
        this.load.image(
            'slider-img-4-activite-3-it',
            'assets/images/activite-3/slider/img1-it.png',
        );
        this.load.image(
            'slider-img-1-activite-3-it',
            'assets/images/activite-3/slider/img2-it.png',
        );
        this.load.image(
            'slider-img-6-activite-3-it',
            'assets/images/activite-3/slider/img3-it.png',
        );
        this.load.image(
            'slider-img-2-activite-3-it',
            'assets/images/activite-3/slider/img4-it.png',
        );
        this.load.image(
            'slider-img-5-activite-3-it',
            'assets/images/activite-3/slider/img5-it.png',
        );
        this.load.image(
            'slider-img-3-activite-3-it',
            'assets/images/activite-3/slider/img6-it.png',
        );

        this.load.image(
            'chaine-img-1-activite-3-it',
            'assets/images/activite-3/chaine/img1-it.png',
        );
        this.load.image(
            'chaine-img-2-activite-3-it',
            'assets/images/activite-3/chaine/img2-it.png',
        );
        this.load.image(
            'chaine-img-3-activite-3-it',
            'assets/images/activite-3/chaine/img3-it.png',
        );
        this.load.image(
            'chaine-img-4-activite-3-it',
            'assets/images/activite-3/chaine/img4-it.png',
        );
        this.load.image(
            'chaine-img-5-activite-3-it',
            'assets/images/activite-3/chaine/img5-it.png',
        );
        this.load.image(
            'chaine-img-6-activite-3-it',
            'assets/images/activite-3/chaine/img6-it.png',
        );

        // activité 4 IT
        this.load.image(
            'bouteille-vide-activite-4-it',
            'assets/images/activite-4/bouteille_message_it.png',
        );

        // End IT
        this.load.image('endScreen-it', 'assets/images/end/end-screen-it.png');

        // vidéos IT
        this.load.video(
            'chaineAlimentaireVideo',
            'assets/videos/it/chaine-alimentaire_it__720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'crabeBleuVideo',
            'assets/videos/it/crabe-bleu_it_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'introVideo',
            'assets/videos/it/intro_it_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'outroVideo',
            'assets/videos/it/outro_it_outro_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'posidonieVideo',
            'assets/videos/it/posidonie_it_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'rorqualVideo',
            'assets/videos/it/rorqual_it_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
    }

    // ----------------- POLONAIS -----------------
    loadPolishSprites() {
        // activité 1 POL
        this.load.image('bouteille-vide-activite-1-pol', 'assets/images/activite-1/image-pol.png');

        // activité 3 POL
        this.load.image(
            'slider-img-4-activite-3-pol',
            'assets/images/activite-3/slider/img1-pol.png',
        );
        this.load.image(
            'slider-img-1-activite-3-pol',
            'assets/images/activite-3/slider/img2-pol.png',
        );
        this.load.image(
            'slider-img-6-activite-3-pol',
            'assets/images/activite-3/slider/img3-pol.png',
        );
        this.load.image(
            'slider-img-2-activite-3-pol',
            'assets/images/activite-3/slider/img4-pol.png',
        );
        this.load.image(
            'slider-img-5-activite-3-pol',
            'assets/images/activite-3/slider/img5-pol.png',
        );
        this.load.image(
            'slider-img-3-activite-3-pol',
            'assets/images/activite-3/slider/img6-pol.png',
        );

        this.load.image(
            'chaine-img-1-activite-3-pol',
            'assets/images/activite-3/chaine/img1-pol.png',
        );
        this.load.image(
            'chaine-img-2-activite-3-pol',
            'assets/images/activite-3/chaine/img2-pol.png',
        );
        this.load.image(
            'chaine-img-3-activite-3-pol',
            'assets/images/activite-3/chaine/img3-pol.png',
        );
        this.load.image(
            'chaine-img-4-activite-3-pol',
            'assets/images/activite-3/chaine/img4-pol.png',
        );
        this.load.image(
            'chaine-img-5-activite-3-pol',
            'assets/images/activite-3/chaine/img5-pol.png',
        );
        this.load.image(
            'chaine-img-6-activite-3-pol',
            'assets/images/activite-3/chaine/img6-pol.png',
        );

        // activité 4 POL
        this.load.image(
            'bouteille-vide-activite-4-pol',
            'assets/images/activite-4/bouteille_message_pol.png',
        );

        // End POL
        this.load.image('endScreen-pol', 'assets/images/end/end-screen-pol.png');

        // vidéos POL
        this.load.video(
            'chaineAlimentaireVideo',
            'assets/videos/pol/chaine-alimentaire_pol_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'crabeBleuVideo',
            'assets/videos/pol/crabe-bleu_pol_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'introVideo',
            'assets/videos/pol/intro_pol_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'outroVideo',
            'assets/videos/pol/outro_pol_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'posidonieVideo',
            'assets/videos/pol/posidonie_pol_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'rorqualVideo',
            'assets/videos/pol/rorqual_pol_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
    }

    // ----------------- ALLEMAND -----------------
    loadGermanSprites() {
        // activité 3 DE
        this.load.image(
            'slider-img-4-activite-3-de',
            'assets/images/activite-3/slider/img1-de.png',
        );
        this.load.image(
            'slider-img-1-activite-3-de',
            'assets/images/activite-3/slider/img2-de.png',
        );
        this.load.image(
            'slider-img-6-activite-3-de',
            'assets/images/activite-3/slider/img3-de.png',
        );
        this.load.image(
            'slider-img-2-activite-3-de',
            'assets/images/activite-3/slider/img4-de.png',
        );
        this.load.image(
            'slider-img-5-activite-3-de',
            'assets/images/activite-3/slider/img5-de.png',
        );
        this.load.image(
            'slider-img-3-activite-3-de',
            'assets/images/activite-3/slider/img6-de.png',
        );

        this.load.image(
            'chaine-img-1-activite-3-de',
            'assets/images/activite-3/chaine/img1-de.png',
        );
        this.load.image(
            'chaine-img-2-activite-3-de',
            'assets/images/activite-3/chaine/img2-de.png',
        );
        this.load.image(
            'chaine-img-3-activite-3-de',
            'assets/images/activite-3/chaine/img3-de.png',
        );
        this.load.image(
            'chaine-img-4-activite-3-de',
            'assets/images/activite-3/chaine/img4-de.png',
        );
        this.load.image(
            'chaine-img-5-activite-3-de',
            'assets/images/activite-3/chaine/img5-de.png',
        );
        this.load.image(
            'chaine-img-6-activite-3-de',
            'assets/images/activite-3/chaine/img6-de.png',
        );

        // activité 4 DE
        this.load.image(
            'bouteille-vide-activite-4-de',
            'assets/images/activite-4/bouteille_message_de.png',
        );

        // End DE
        this.load.image('endScreen-de', 'assets/images/end/end-screen-de.png');

        // vidéos DE
        this.load.video(
            'chaineAlimentaireVideo',
            'assets/videos/de/chaine-alimentaire_de__720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'crabeBleuVideo',
            'assets/videos/de/crabe-bleu_de_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'introVideo',
            'assets/videos/de/intro_de_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'outroVideo',
            'assets/videos/de/outro_de_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'posidonieVideo',
            'assets/videos/de/posidonie_de_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'rorqualVideo',
            'assets/videos/de/rorqual_de_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
    }

    // ----------------- ESPAGNOL -----------------
    loadSpanishSprites() {
        this.load.image('bouteille-vide-activite-1', 'assets/images/activite-1/image.png');
        this.load.image('animal-1-activite-1', 'assets/images/activite-1/image-grande-1.png');
        this.load.image('animal-2-activite-1', 'assets/images/activite-1/image-grande-2.png');
        this.load.image('animal-3-activite-1', 'assets/images/activite-1/image-grande-3.png');
        this.load.image('animal-4-activite-1', 'assets/images/activite-1/image-grande-4.png');
        this.load.image('animal-5-activite-1', 'assets/images/activite-1/image-grande-5.png');
        // activité 3 ES
        this.load.image(
            'bouteille-vide-activite-3-es',
            'assets/images/activite-3/bouteille-message-es.png',
        );
        this.load.image(
            'slider-img-4-activite-3-es',
            'assets/images/activite-3/slider/img1-es.png',
        );
        this.load.image(
            'slider-img-1-activite-3-es',
            'assets/images/activite-3/slider/img2-es.png',
        );
        this.load.image(
            'slider-img-6-activite-3-es',
            'assets/images/activite-3/slider/img3-es.png',
        );
        this.load.image(
            'slider-img-2-activite-3-es',
            'assets/images/activite-3/slider/img4-es.png',
        );
        this.load.image(
            'slider-img-5-activite-3-es',
            'assets/images/activite-3/slider/img5-es.png',
        );
        this.load.image(
            'slider-img-3-activite-3-es',
            'assets/images/activite-3/slider/img6-es.png',
        );

        this.load.image(
            'chaine-img-1-activite-3-es',
            'assets/images/activite-3/chaine/img1-es.png',
        );
        this.load.image(
            'chaine-img-2-activite-3-es',
            'assets/images/activite-3/chaine/img2-es.png',
        );
        this.load.image(
            'chaine-img-3-activite-3-es',
            'assets/images/activite-3/chaine/img3-es.png',
        );
        this.load.image(
            'chaine-img-4-activite-3-es',
            'assets/images/activite-3/chaine/img4-es.png',
        );
        this.load.image(
            'chaine-img-5-activite-3-es',
            'assets/images/activite-3/chaine/img5-es.png',
        );
        this.load.image(
            'chaine-img-6-activite-3-es',
            'assets/images/activite-3/chaine/img6-es.png',
        );

        // activité 4 ES : (pas de bouteille spécifique dans ton code, donc rien ici)
        this.load.image(
            'bouteille-vide-activite-4-es',
            'assets/images/activite-4/bouteille_message_es.png',
        );

        // End ES
        this.load.image('endScreen-es', 'assets/images/end/end-screen-es.png');

        // vidéos ES (c’est déjà comme ça dans ton code, je les laisse)
        this.load.video(
            'chaineAlimentaireVideo-es',
            'assets/videos/es/chaine-alimentaire_es__720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'crabeBleuVideo',
            'assets/videos/es/crabe-bleu_es_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'introVideo',
            'assets/videos/es/intro_es_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'outroVideo-es',
            'assets/videos/es/outro_es_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'posidonieVideo-es',
            'assets/videos/es/posidonie_es_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
        this.load.video(
            'rorqualVideo-es',
            'assets/videos/es/rorqual_es_720p_25fps_qualite_35.mp4',
            'loadeddata',
            true,
        );
    }
}
